import * as React from "react";
import * as Sentry from "@sentry/react";
import { Button } from "@/components/ui/button";

type FallbackProps = {
  resetError: () => void;
};

const ErrorFallback = ({ resetError }: FallbackProps) => (
  <div className="flex min-h-dvh w-full flex-col items-center justify-center gap-4 p-8 text-center">
    <h1 className="font-jakarta-sans text-2xl font-semibold">Une erreur est survenue</h1>
    <p className="max-w-md text-gray-600">
      L'affichage de cette page a été interrompu. Vous pouvez réessayer&nbsp;; si le problème
      persiste, veuillez contacter l'équipe Pelican.
    </p>
    <div className="flex flex-row gap-2">
      <Button onClick={resetError}>Réessayer</Button>
      <Button variant="outline" onClick={() => window.location.reload()}>
        Recharger la page
      </Button>
    </div>
  </div>
);

export const AppErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
    {children}
  </Sentry.ErrorBoundary>
);
